// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import axios from 'axios'
import api from './api/api'
import store from './store'
import VueI18n from 'vue-i18n'
Vue.prototype.apiUrl = api

import './assets/iconfont/iconfont.js'

Vue.use(ElementUI)
// Vue.prototype.$axios = axios

// Vue.prototype.ImgUrl = 'http://47.240.11.130:8899/pictures/'
// Vue.prototype.detailsImgUrl = 'http://47.240.11.130:8899'
// Vue.prototype.ImgUrl = ''
// Vue.prototype.detailsImgUrl = ''

import { MessageBox, Loading, Message } from 'element-ui';

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$prompt = MessageBox.prompt;

// Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Vue.config.productionTip = false

Vue.use(VueI18n)
import zh from './language/zh.js'
import vn from './language/vn.js'
const i18n = new VueI18n({
  locale: 'vn', // 语言标识
  messages: {
    'zh': zh,
    'vn': vn
  }
})
import './http/index.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-FCK23VR5B2" }
}, router);

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js